import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from "i18next-http-backend";

import translationDe from "./locales/de/translation.json";
import translationEn from "./locales/en/translation.json";

const options = {
    order: ['querystring', 'navigator'],
    lookupQuerystring: 'lng'
}

const resources = {
    de: {
        translation: translationDe,
    },
    en: {
        translation: translationEn,
    },
};


i18n
    .use(XHR)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: options,
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: resources
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js